<template>
  <div class="mask">
    <!-- 绑定手机号弹窗 -->
    <div class="bindDialog" v-if="bindDialogIsShow">
      <div class="icon_close" @click="closeBindDialog"></div>
      <div class="bindTitle">绑定手机号</div>
      <div class="bindTel">
        <input type="text" placeholder="请输入手机号" v-model="tel" />
      </div>
			<div class="verifyImg">
				<input type="number" v-model="imgCode" placeholder="请输入图形验证码" :contextmenu="false">
				<img v-if="verifyImg" :src="verifyImg" alt="" @click="changeVerifyImg" :title="verifyImgTitle">
			</div>
      <div class="bindCode">
        <input type="text" placeholder="请输入验证码" v-model="code" />
        <div class="sendBtn" @click="sendCode" v-if="!cutdownIsShow">
          发送手机验证码
        </div>
        <!-- 倒计时 -->
        <div class="sendBtn second" v-if="cutdownIsShow">
          {{ sendtxt }}
        </div>
      </div>
      <!-- 绑定按钮（手机号和验证码都存在时可点，否则置灰不可点击） -->
      <div class="bindBtn" @click="bindPhone" :class="{ canBind: canBind }">
        绑定
      </div>
    </div>
    <!-- 手机号已绑定弹窗 -->
    <div class="boundDialog" v-if="boundDialogIsShow">
      <div class="icon_close" @click="closeBindDialog"></div>
      <div class="boundTitle">绑定失败</div>
      <div class="telInfo">您的手机号 {{ this.tel }} 已被下方账号绑定</div>
      <div class="userInfo">
        <div class="leftInfo">
          <div class="userHeadImg">
            <img :src="userHeadImg" alt="" />
          </div>
        </div>
        <div class="centerInfo">
          <div class="userName">{{ userName }}</div>
          <div class="text">{{ this.tel }}</div>
        </div>
        <div class="loginBtn" @click="loginThisCount">登录此账号</div>
      </div>
      <div class="gotoBindOther" @click="gotoBindOther">绑定其他手机号</div>
    </div>
  </div>
</template>

<script>
import { getIPs, getBrowserNameVersion,ipToNumber,generateLetters,replaceCharAtIndex } from '@/config/getSysInfo.js'
import md5 from 'js-md5';
import { Toast } from 'vant'
import Qs from 'qs'
import { ADDRESS } from '@/api/address.js'
export default {
  name: '',
  data() {
    return {
      tel: '',
      code: '',
      cutdownIsShow: false,
      sendtxt: '',
      // 倒计时
      time: 60,
      // 控制绑定按钮置灰或可点
      canBind: false,
      // 手机号已绑定弹窗
      phoneIsBind: false,
      // 显示绑定弹窗
      bindDialogIsShow: true,
      // 显示手机号已绑定弹窗
      boundDialogIsShow: false,
      // 绑定所需
      thirdCode: '',
      clientType: '1',
      // 已绑定的信息
      userHeadImg: '',
      userName: '',
      token: '',
			// 2023年06获取短信验证码优化
			imgCode: '',
			statistics: '',
			source: '33',
			
			verifyImg: '',
			
			reqId_Len_A: '',
			reqId: '',
			reqTime: '',
			ip: '',
			reqCode: '',
			verifyImgTitle: '点击切换'
    }
  },
  computed: {
    // 用户是否可以点击绑定按钮（手机号和验证码是否存在）
    userCanBind() {
      const { tel, code, imgCode } = this
      return { tel, code, imgCode }
    }
  },
  watch: {
    // 用户是否可以点击绑定按钮（手机号和验证码是否存在）
    userCanBind: {
      handler(newval, oldval) {
				const regExp = new RegExp("^1[3456789]\\d{9}$");
        console.log(newval, oldval)
        if (regExp.test(newval.tel) && this.code && this.imgCode.length === 4) {
          this.canBind = true
        } else {
          this.canBind = false
        }
      },
      deep: true
    }
  },
  created() {
    window.addEventListener('beforeunload', (e) => this.handleRefresh(e))
    window.parent.postMessage({ command: 'loginIsShow' }, '*')
    this.thirdCode = this.$cookies.get('thirdCode')
    this.loginType = this.$cookies.get('login_type')
  },
  mounted() {
		this.getSysInfo()
    console.log('绑定页的mounted')
    window.addEventListener('message', function(event) {
      console.log('收到', event)
      if (event.data.command == 'parentUrl') {
        console.log('收到父页面url0551', event)
        this.$cookies.set('login_origin', event.data.url, '1d','','zhibo.tv')
      }
    })
  },
  beforeDestroy() {
    console.log('beforeDestroy')
  },
  methods: {
		changeVerifyImg(){
			const regExp = new RegExp("^1[3456789]\\d{9}$");
			if(!regExp.test(this.tel)) return Toast('请输入正确的手机号')
			if(this.cutdownIsShow) return Toast(`${this.time}s后可切换`)
			
			this.cutdownIsShow = true
			this.time = 6
			this.timer()
			this.getSysInfo()
		},
		async getReqId(res,t){
			const { source, statistics } = this;
			let params = `source=${source}&statistics=${statistics}`
			if(res != 'success'){
				params += `&time=${t}`
			}
			const { data } = await this.$api.getReqId(params)
			const { reqId, code, time, ip } = data.data;
			
			this.verifyImg = ADDRESS.address2 + '/user/verify?reqId=' + reqId + '&statistics=' + this.statistics//图形验证码
			
			this.reqId_Len_A = Number(code.charAt(0)) - 5;//A段长度
			this.reqId = reqId;
			this.reqCode = code;
			this.reqTime = time;
			this.ip = ip;
		},
		getSysInfo(){
			getIPs((ip,res) => {
				const VS = getBrowserNameVersion();
				const platform = 'pc';//平台  pc ios android
				const channel = VS.split(' ')[0];//渠道 360 小米 chrome 
				let version = '2.0';//接口版本号
				let deviceId = ipToNumber(ip);//设备号 ip
				let time = ''
				if(res != 'success'){
					deviceId = Number(ipToNumber(ip)) + Number(this.source) + Number(parseInt(new Date().getTime() / 1000))
					time = parseInt(new Date().getTime() / 1000)
				}
				const model = VS.split(' ')[1] ? VS.split(' ')[1] : '1';//浏览器版本
				const useragent = encodeURI(navigator.userAgent);
				const imei = btoa(useragent);//base64位 系统信息
				let str = platform + '|' + channel + '|' + version + '|' + deviceId + '|' + model + '|' + imei + '|' + 'local' + '|' + '5.5.5' + '|' + 'jhkz7thw7829@0*1'
				str = md5(str)
				str = str.substring(str.length - 8)
				version += `-${str}`;
				this.statistics = platform + '|' + channel + '|' + version + '|' + deviceId + '|' + model + '|' + imei + '|' + 'local' + '|' + '5.5.5'
				this.getReqId(res,time)
			})
		},
    // 处理刷新
    handleRefresh() {
      console.log('刷新')
      this.$cookies.set('isThirdNew', '-1', '1d', null, 'zhibo.tv')
      this.$cookies.set('thirdCode', '-1', '1d')
    },
    // 关闭按钮
    closeBindDialog() {
      this.$cookies.set('isThirdNew', '-1', '1d', null, 'zhibo.tv')
      this.$cookies.set('thirdCode', '-1', '1d')
      this.$emit('closeBindDialog')
      window.parent.postMessage({ command: 'reload' }, '*')
    },
		setReqId() {
			const reqId_first_code = (this.reqId.charAt(0)).charCodeAt()
			const phone_last_nine = Number(this.tel.substring(2)) + Number(reqId_first_code);//手机号后九位 + reqId第一位的ascii码
			const remainder_number = phone_last_nine % 26;//除以26取余 0-25
			const remainder_letter = String.fromCharCode(Number(remainder_number) + Number(97));//手机号后9位+reqId第一位的ascii码,%26取余,对应a-z
			const remainder_index = phone_last_nine % 4;//手机号后9位+reqId第一位的ascii码,%4取余
			let str = generateLetters(4)//生成一个随机字母字符
			str = replaceCharAtIndex(str,remainder_index,1,remainder_letter)//替换 字符,开始索引,长度,值
			// console.log('重排后得reqId==========>',replaceCharAtIndex(this.reqId,this.reqId_Len_A,4,str))
			return replaceCharAtIndex(this.reqId,this.reqId_Len_A,4,str)
		},
		sortArray() {
			const { setReqId, tel, imgCode, reqTime, source, ip, statistics } = this;
			let newReqId = setReqId();
			let reqId = md5(newReqId + '$^>*<@' + 'JHKZ7THW7829@0*1');
			reqId = reqId.substring(reqId.length - 6)
			reqId = newReqId + reqId
			//key值按照a-z的顺序拼接
			const params = {code: imgCode, ip: ip, phone: tel, reqId: reqId, source: source, time: reqTime}
			let str = '';
			Object.values(params).forEach(e=>{
				str += `${e}&`
			})
			str = str + 'jhkz7thw7829@0*1'
			str = md5(str)
			str = str.substring(str.length - 8)
			params.sign = str
			params.statistics = statistics
			return params
		},
    // 发送验证码
    async sendCode() {
			if(this.cutdownIsShow) return
			const regExp = new RegExp("^1[3456789]\\d{9}$");
			if(regExp.test(this.tel)){
				if(this.imgCode.length === 4){
					const params = this.sortArray()
					const res = await this.$api.sendCodefromPC(Qs.stringify(params))
					if (res.data.control.status == 200) {
						this.time = 60
					} else {
						this.imgCode = ''
						this.time = 6
						this.getSysInfo()
					}
					this.cutdownIsShow = true
					Toast(res.data.control.message)
					this.timer()
				}else{
					Toast('请输入正确的图形验证码')
				}
			}else{
				Toast('请输入正确的手机号')
			}
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 1) {
        this.time--
        this.sendtxt = this.time + 's后获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.cutdownIsShow = false
      }
    },
    // 绑定手机号
    async bindPhone() {
      if (this.userCanBind) {
        // Toast('调接口2：绑定手机号，手机号+验证码+openid+accesstoken绑定')
        let params = {
          loginType: this.loginType,
          code: this.thirdCode,
          clientType: this.clientType,
          phone: this.tel,
          number: this.code
        }
        let res = await this.$api.gotoBindtel(Qs.stringify(params))
        console.log(res)
        // bindType 1新用户绑定成功 2手机号已经绑定
        if (res.data.control.status == 200) {
          if (res.data.data.bindType == 1) {
            Toast('绑定成功')
            this.$cookies.set('isThirdNew', '-1', '1d', null, 'zhibo.tv')
            this.$cookies.set('thirdCode', '-1', '1d')
            window.parent.postMessage({ command: 'reload' }, '*')
          } else if (res.data.data.bindType == 2) {
            // 关闭绑定弹窗
            this.bindDialogIsShow = false
            // 展示已绑定弹窗
            this.userHeadImg = res.data.data.userHeadImg
            this.userName = res.data.data.userName
            this.token = res.data.data.token
            this.boundDialogIsShow = true
          }
        } else {
          Toast(res.data.control.message)
          // window.parent.postMessage({ command: 'reload' }, '*')
        }
      }
    },
    // 登录此账号
    async loginThisCount() {
      // Toast('调接口3：手机号登录，30秒有效期')
      let params = {
        token: this.token
      }
      let res = await this.$api.loginByToken(params)
      console.log(res)
      if (res.data.control.status == 200) {
        this.$cookies.set('isThirdNew', '-1', '1d', null, 'zhibo.tv')
        this.$cookies.set('thirdCode', '-1', '1d')
        Toast('登录成功')
        window.parent.postMessage({ command: 'reload' }, '*')
      } else {
        Toast(res.data.control.message)
        window.parent.postMessage({ command: 'reload' }, '*')
      }
    },
    // 绑定其他手机号
    gotoBindOther() {
      this.tel = ''
      this.code = ''
      this.time = 60
      this.cutdownIsShow = false
      // 展示绑定弹窗
      this.bindDialogIsShow = true
      // 关闭已绑定弹窗
      this.boundDialogIsShow = false
    }
  }
}
</script>

<style lang="less" scoped>
.mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  .icon_close {
    width: 25px;
    height: 25px;
    background: url('https://images.zhibo.tv/2021/0507/close_icon.png')
      no-repeat center;
    background-size: 100%;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
  .bindDialog {
    width: 400px;
    height: 442px;
    background: #ffffff;
    border-radius: 4px;
    padding: 30px 40px;
    box-sizing: border-box;
    position: relative;

    .bindTitle {
      margin-bottom: 30px;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #354052;
    }
    .bindTel {
      width: 320px;
      height: 60px;
      background: #ffffff;
      border-bottom: 1px solid #e5e5e5;
      margin-bottom: 20px;
      input {
        display: block;
        width: 320px;
        height: 60px;
        background: #ffffff;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
      }
      input::placeholder {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
      }
    }
		
		.verifyImg{
			width: 320px;
			height: 60px;
			background: #ffffff;
			margin-bottom: 30px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #e5e5e5;
			input {
				display: block;
				width: 160px;
				height: 60px;
				background: #ffffff;
				font-size: 18px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #222222;
				&::-webkit-inner-spin-button {
					-webkit-appearance: none !important;
				}
			}
			input::placeholder {
				font-size: 16px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #999999;
			}
			img{
				pointer-events: unset;
				cursor: pointer;
			}
		}
    .bindCode {
      width: 320px;
      height: 60px;
      background: #ffffff;
      margin-bottom: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #e5e5e5;
      input {
        display: block;
        width: 160px;
        height: 60px;
        background: #ffffff;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
      }
      input::placeholder {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        // line-height: 27px;
      }
      .sendBtn {
        width: 98px;
        height: 40px;
        // background: #E9001d;
        border-radius: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        &:hover {
          color: #e9001d;
        }
      }
      .second {
        color: #999999;
      }
    }

    .bindBtn {
      width: 320px;
      height: 50px;
      background: #cccccc;
      border-radius: 25px;
      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
    .canBind {
      cursor: pointer;
      background: #e9001d;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .boundDialog {
    width: 460px;
    height: 324px;
    background: #ffffff;
    border-radius: 4px;
    position: relative;
    box-sizing: border-box;
    padding: 30px 40px;
    .boundTitle {
      margin-bottom: 30px;
      text-align: center;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .telInfo {
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .userInfo {
      width: 380px;
      height: 82px;
      background: #f5f5f5;
      border-radius: 4px;
      margin: 16px 0 40px 0;
      box-sizing: border-box;
      padding: 16px 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .leftInfo {
        .userHeadImg {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
          img {
            display: block;
            width: 50px;
            height: 50px;
          }
        }
      }
      .centerInfo {
        flex: 1;
        .userName {
          margin-bottom: 6px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #666666;
          line-height: 20px;
        }
        .text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
      .loginBtn {
        width: 86px;
        height: 32px;
        border-radius: 17px;
        border: 1px solid #e9001d;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        font-size: 13px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #e9001d;
        &:hover {
          opacity: 0.9;
        }
      }
    }
    .gotoBindOther {
      width: 208px;
      height: 50px;
      margin: 0 auto;
      background: #e9001d;
      border-radius: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
